import React from 'react';
import { ProfileContext } from './profile.context';

const useProfileContext = () => React.useContext(ProfileContext);

export { useProfileContext };
